import React from 'react';
import './App.sass';
import HomePage from './components/HomePage/HomePage';

function App() {
  return (
    <>
      <HomePage />
    </>
  );
}

export default App;
